import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";

/**
 * Create router instance with context
 * - Passes QueryClient to all routes
 * - Provides type-safe context access
 */
function createRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        retry: typeof window === "undefined" ? false : 3,
      },
      mutations: {
        retry: false,
      },
    },
  });

  const router = createTanStackRouter({
    routeTree,
    context: {
      queryClient,
      user: null,
      theme: "light" as const,
    },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
  });
  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  });
  return router;
}

/**
 * Export getRouter for TanStack Start
 * Returns a promise of the router instance
 */
export async function getRouter() {
  return createRouter();
}

/**
 * Register router for type safety
 */
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
